// extracted by mini-css-extract-plugin
module.exports = {"mapContainer":"MapWithMarker_mapContainer__3NaXp","container":"MapWithMarker_container__NIXxf","dragNote":"MapWithMarker_dragNote__2bCRp","note":"MapWithMarker_note__2PbdF"};